const TeaserCarousel = el =>{
    const controls = el.querySelector("[data-slider-controls]");
    const items = el.querySelector("[data-items]");
    try {
        const slider = tns({
            container: items,
            items: 1,
            edgePadding: 0,
            autoplay: false,
            controls: true,
            controlsContainer: controls,
            autoplayButton: false,
            autoplayTimeout: 5000,
            gutter: 0,
            nav: false,
            loop: false,
            responsive: {
                "768": { "items": 2},
                "992": { "items": 3 }
            },
            onInit: () => removeFocusableItems(items, controls),

        });

        const doRemoveFocusableItems = () => removeFocusableItems(Array.from(slider.getInfo().slideItems));

        slider.events.on(`transitionStart`, ()=> doRemoveFocusableItems);
        slider.events.on(`newBreakpointEnd`, ()=> doRemoveFocusableItems);
        slider.events.on(`indexChanged`, ()=> {
            doRemoveFocusableItems();
        });

    } catch (error) {
        console.error("Error initializing Tiny Slider:", error);
    }
}

const removeFocusableItems = (items, controls) => {
    const slides = items instanceof Element
        ? items.querySelectorAll('.tns-item')
        : items;
    
    slides.forEach(slide => {
        const tabIndexVal = slide.classList.contains('tns-slide-active') ? "" : -1;
        slide.querySelectorAll('a, button').forEach(link => link.tabIndex = tabIndexVal);
    });
    
    if(controls && controls.hasAttribute("aria-label")){
        controls.removeAttribute("aria-label");
    }
}

document.querySelectorAll('[data-teaser-carousel]').forEach(el => {
    TeaserCarousel(el);
});


